//import {Container, Col, Row }from 'react-bootstrap';

function ContentGDProjectText(){
    return (
        <> 
            <p className="py-0 text-start font-body color-font-primary font-size-large">Combining Graphic Design and Performance Purpose</p>
            <p className="py-0 text-start font-body color-font-primary font-size-small">Moisture-wicking fabrics are engineered to pull perspiration away from the skin, transport it to the fabric`s outer surface, and accelerate evaporation. This process keeps the wearer drier, cooler, and more comfortable during physical activity. The tail of the head tie creates a system that pulls sweat from the forehead and allows it to drip off the back. This means there is less sweat that can fall into the eyes and break the wearer`s concentration.</p>
            <p className="py-0 text-start font-body color-font-primary font-size-small">The down arrow design is a nod to the Avatar Series’ Air Nomads. Endurance athletes train and test both their aerobic and anaerobic abilities in order to achieve peak performance.  We use the arrow to represent the intersection between sport, storytelling and the air we all breathe. 
            </p>

            
        </>
    )
}

export default ContentGDProjectText;